<app-svg-load-morph-animation></app-svg-load-morph-animation>

<head>
  <link rel="stylesheet" href="https://fonts.googleapis.com/icon?family=Material+Icons" />
</head>

<app-generic-side-modal-container [sideNavTitleText]="'Daily Schedule' | translate" class="h-full"> 
  <div mainPageContent class="padding_20 h-full overflow-clip">
    
    <div class="flex flex-col lg:flex-row gap-5 justify-between items-baseline" style="color: #475569">
      <h1 class="uppercase text-[#475569] font-bold text-3xl lg:text-4xl">{{"Appointments" | translate}}</h1>
    </div>

    <div class="bg-white w-full rounded-xl shadow-sm border-solid border-[0.025rem] p-7 my-[3.25rem]">
      <form [formGroup]="searchForm" #searchNgForm="ngForm" class="w-full">
        <div class="flex flex-col w-full gap-5">
          <div class="w-full flex flex-row justify-between mb-[1.85rem]">
            <p class="font-semibold text-[#475569]">{{'Search term' |
              translate}}</p>
          </div>
          
          <div class="flex flex-col 2xl:flex-row w-full justify-between gap-3 lg:gap-[2rem]">
            
            <div class="flex flex-col gap-1 w-full">
              <mat-label>{{"Search service type" | translate}}</mat-label>
              <mat-form-field appearance="outline" class="flex flex-row items-center">
                
                <mat-icon matPrefix><i class="fa-regular fa-spa text-[2rem] pr-[1rem]"></i>
                </mat-icon>
  
                <mat-select [(ngModel)]="selectedServiceId" (selectionChange)="refreshCalendar()"  
                  name="selectionId2" placeholder='{{"select" | translate}}'  id="selectionId2" 
                  [ngModelOptions]="{standalone: true}">
                  <mat-option [value]="null"> {{"Show all" | translate}} </mat-option>
                  <mat-option *ngFor="let service of serviceData" [value]="service.id"> {{service.name}} </mat-option>
                  <mat-option *ngIf="serviceData?.length == 0"> {{"Not found services" | translate}} </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
  
            <div class="flex flex-col gap-1 w-full">
              <mat-label>{{"Select a client" | translate}}</mat-label>
              <mat-form-field appearance="outline" class="flex flex-row items-center">
                
                <mat-icon matPrefix><i class="fa-regular fa-user text-[2rem] pr-[1rem]"></i>
                </mat-icon>
  
                <mat-select (selectionChange)="refreshCalendar()" placeholder='{{"Select a client" | translate}}' name="client" [(ngModel)]="selectedClientId"
                [ngModelOptions]="{standalone: true}">
                  <mat-option [value]="null">{{"Show all" | translate}}</mat-option>
                  <mat-option *ngFor="let client of clientsData"  [value]="client.profileId"> {{client.name}} {{client.surname}} </mat-option>
                  <mat-option *ngIf="clientsData?.length == 0"> {{"Not found clients" | translate}} </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
  
            <div class="flex flex-col gap-1 w-full">
              <mat-label>{{ "Not registered user" | translate }}</mat-label>
              <mat-form-field appearance="outline" class="flex flex-row items-center">
                <mat-icon matPrefix><i class="fa-regular fa-user text-[2rem] pr-[1rem]"></i></mat-icon>
                <input [formControlName]="'serviceType'" matInput type="text" placeholder="{{ 'Search' | translate }}"
                  id="param" (keyup.enter)="refreshCalendar()" />
              </mat-form-field>
            </div>            
  
          </div>
        </div>
      </form>

    </div>
    
    <full-calendar #calendar [options]="calendarOptions"></full-calendar>

  </div>

  <div sideNavContent class="w-full min-w-[35vw] xl:min-w-0">
    <div class="flex flex-col gap-[2rem] justify-center align-middle items-center 
    overflow-y-auto overflow-x-hidden w-full px-[1rem] pt-[1.5rem] pb-[2rem] mt-[-1.5rem]" *ngIf="todayTermData!.length != 0">
      
      <div *ngFor="let term of todayTermData" class="w-full">
        <div class="mat-elevation-z8 mid-box w-full" style="padding: 2vh; width: full; height: max-content"> 
          <div class="daySheduling">
            <div style="display: flex; justify-content: space-between; width: 100%">
              <span style="font-size: 1.6rem; font-weight: bold; display: block; margin-bottom: 1vh;">{{term.fromDate | date:"HH:mm"}} - {{term.toDate | date:"HH:mm"}}</span>
              <div>
                <span class="timeStyle" style="font-size: 1.5rem;">{{ calculateTotalMinutesDifference(term) }} {{"minutes" | translate }}</span>
              </div>
            </div>
        
            <div class="w-full">
              <div style="display: grid;">
                <span style="font-size: 1.4rem; font-weight: bold">{{term.serviceName}}</span>
                <span style="font-size: 1.4rem;">{{term.name}} {{term.surname}}</span>
              </div>
        
            </div>

            <div class="w-full" style="margin-top: 2vh;">
              <mat-divider style="border-top-color: #000; margin-bottom: 1rem;"></mat-divider>
              <span style="font-size: 1.3rem; display: flex; align-items: center;">
                <svg style="margin-right: 1vh;"
                  xmlns="http://www.w3.org/2000/svg" height="17" width="17" viewBox="0 0 512 512">
                  <path
                    d="M406.5 399.6C387.4 352.9 341.5 320 288 320H224c-53.5 0-99.4 32.9-118.5 79.6C69.9 362.2 48 311.7 48 256C48 141.1 141.1 48 256 48s208 93.1 208 208c0 55.7-21.9 106.2-57.5 143.6zm-40.1 32.7C334.4 452.4 296.6 464 256 464s-78.4-11.6-110.5-31.7c7.3-36.7 39.7-64.3 78.5-64.3h64c38.8 0 71.2 27.6 78.5 64.3zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-272a40 40 0 1 1 0-80 40 40 0 1 1 0 80zm-88-40a88 88 0 1 0 176 0 88 88 0 1 0 -176 0z" />
                </svg> {{"Employee" | translate}}: {{term.employeeName}} {{term.employeeSurname}}</span>
            </div>
          </div>
        
        </div>

      </div>

    </div>

    <div class="flex flex-col gap-[2rem] justify-center align-middle items-center
    overflow-y-auto overflow-x-hidden w-full pt-[1.5rem] pb-[2rem] mt-[-1.5rem]" *ngIf="todayTermData?.length === 0">
      <div class="w-full flex flex-row justify-center align-middle text-center">
          <p class="text-[1.35rem] md:text-[1.5rem] text-black mt-[1rem]"> {{"No daily schedule currently found" | translate}} </p>
      </div>
    </div>

  </div>
</app-generic-side-modal-container>

<!--Add and edit popups on term -->
<app-generic-modal *ngIf="addTermPopupState" [bannerText]="'Add term' | translate " [handle_extreme_overflow]="false"
  [handle_mobile]="true" (handleCloseEmitter)="closePopupOnButton()">
  <app-term-add-popup (close)="closePopupOnButton()"></app-term-add-popup>
</app-generic-modal>

<app-generic-modal *ngIf="editTermPopupState" [bannerText]="'Edit term' | translate " [handle_extreme_overflow]="false"
  [handle_mobile]="true" (handleCloseEmitter)="closePopupOnButton()">
  <app-term-edit-popup  (close)="closePopupOnButton()" [arg]="arg" [termId]="termId" [mergeFromDate]="mergeFromDate" [mergeToDate]="mergeToDate"></app-term-edit-popup>
</app-generic-modal>

<!--Add non working day popup -->
<app-generic-modal *ngIf="addNonWorkingDayPopupState" [bannerText]="'days off' | translate " [handle_extreme_overflow]="false"
  [handle_mobile]="true" (handleCloseEmitter)="closePopupOnButton()">
  <app-holiday-day-popup (close)="closePopupOnButton()"></app-holiday-day-popup>
</app-generic-modal>






